import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NextLink from 'next/link';
import InfoIcon from '~/assets/icons/ontario-icon-alert-information.svg';
import { Container, InnerContainer, StyledCloseIcon, StyledCreateAccount } from './styles';

const CreateAccountBanner: React.FC = () => {
    const { t } = useTranslation('base-layout');
    const [showCreateAccount, setShowCreateAccount] = useState<boolean>(true);

    const handleClick = () => {
        setShowCreateAccount(!showCreateAccount);
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            handleClick();
        }
    };

    return (
        showCreateAccount && (
            <nav aria-label="account">
                <Container>
                    <InnerContainer>
                        <StyledCreateAccount>
                            <InfoIcon />
                            <span>
                                <NextLink href="/splash">
                                    {' '}
                                    {t('createAccountBanner.createOr')}
                                </NextLink>
                                {t('createAccountBanner.text')}
                            </span>
                        </StyledCreateAccount>
                        <StyledCloseIcon
                            tabIndex={0}
                            aria-label={t('closeAriaLabel') ?? ''}
                            onClick={handleClick}
                            onKeyDown={handleKeyDown}
                            role="button"
                        />
                    </InnerContainer>
                </Container>
            </nav>
        )
    );
};

export default CreateAccountBanner;
